require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/fn/symbol/iterator.js
// module id = 448
// module chunks = 1